import { useTranslation } from "react-i18next";
import { useSurveyLayout } from "../useSurveyLayout";
import { surveyForm, withForm } from "../hooks/surveyResponseFormHooks";

type FieldMeta = Record<string, { isDirty?: boolean } | undefined>;

const StatusBar = withForm({
    ...surveyForm,
    render: function Render({ form }) {
        const { t } = useTranslation();
        const { currentQuestionIndex, questions } = useSurveyLayout();
        const total = questions?.length || 0;

        return (
            <form.Subscribe
                selector={(state) => ({
                    fieldMeta: state.fieldMeta as FieldMeta,
                    values: state.values,
                })}
            >
                {({ fieldMeta, values }) => {
                    // Count questions that have been touched (answered or skipped)
                    const answers = values.answers;
                    let touchedCount = 0;

                    for (let i = 0; i < total; i++) {
                        const meta = fieldMeta[`answers[${i}].answerValue`];
                        const answer = answers?.[i];

                        // Count as touched if field is dirty OR has a value
                        if (
                            meta?.isDirty ||
                            (answer?.answerValue !== undefined && answer?.answerValue !== null)
                        ) {
                            touchedCount++;
                        }
                    }

                    const percentComplete =
                        total > 0 ? Math.round((touchedCount / total) * 100) : 0;

                    const fillColor =
                        percentComplete < 33
                            ? "bg-chameleon-pink"
                            : percentComplete < 66
                              ? "bg-chameleon-yellow"
                              : "bg-chameleon-green";

                    return (
                        <>
                            <div className="flex justify-between items-center mb-1">
                                <div className="text-sm font-light">
                                    {currentQuestionIndex + 1} {t("common.of")} {total}{" "}
                                    {t("surveyResponse.questions")}
                                </div>
                                <div className="text-sm font-light">
                                    {percentComplete}% {t("surveyResponse.complete")}
                                </div>
                            </div>

                            <div className="h-2 bg-compendia-greige-60 rounded-full mb-4">
                                <div
                                    className={`h-2 rounded-full transition-all duration-500 ${fillColor}`}
                                    style={{ width: `${percentComplete}%` }}
                                ></div>
                            </div>
                        </>
                    );
                }}
            </form.Subscribe>
        );
    },
});

export default StatusBar;
